import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ContextSetupSet, ContextSetup } from '../models/context-setup.model';
import { Templates } from '../models/template.model';

@Injectable({
  providedIn: 'root'
})
export class SearchConfigService {

  constructor(private readonly http: HttpClient) { }

  /** Aggiorna un contesto con nuovi parametri */
  updateContextSetup(contextId: string, requestBody: ContextSetupSet) {
    return this.http.put<ContextSetup>(
      `${environment.apiGatewayUrl}/servingconfigs/api/v1/contexts/${contextId}`,
      requestBody
    );
  }

  /** Aggiorna un contesto in modalità preview con nuovi parametri */
  updateContextSetupPreview(contextId: string, requestBody: ContextSetupSet) {
    return this.http.put<ContextSetup>(
      `${environment.apiGatewayUrl}/servingconfigs/api/v1/contexts/${contextId}/preview`,
      requestBody
    );
  }

  /** Recupera i dettagli di un contesto specifico */
  getContextSetup(contextId: string) {
    return this.http.get<ContextSetup>(`${environment.apiGatewayUrl}/servingconfigs/api/v1/contexts/${contextId}`);
  }

  /** Ottiene la lista dei template disponibili */
  getTemplates() {
    return this.http.get<Templates>(`${environment.apiGatewayUrl}/servingconfigs/api/v1/templates`);
  }

  /** Ottiene la lista dei modelli disponibili */
  getModels() {
    return this.http.get<any[]>(`${environment.apiGatewayUrl}/servingconfigs/api/v1/models`);
  }

  /** Ottiene la lista delle lingue disponibili */
  getLanguages() {
    return this.http.get<any>('json/languages.json');
  }
}
